import { render } from "./ApplyRefund.vue?vue&type=template&id=5808b980"
import script from "./ApplyRefund.vue?vue&type=script&lang=js"
export * from "./ApplyRefund.vue?vue&type=script&lang=js"

import "./ApplyRefund.vue?vue&type=style&index=0&id=5808b980&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__